<template>
	<div class="login-box">		
		<div class="form_area">
			<div style="display: flex;justify-content: flex-end;">
				<div @click="toIndex" class="home_btn">返回首页</div>
			</div>
			<div style="text-align: center;position: relative;">
				<img class="title-logo" src="../assets/imgs/logo-img.png">
			</div>
			<el-form :model="loginForm" :rules="loginRules" ref="loginForm">
				<el-form-item prop="username">
					<div class="form_item">
						<el-input clearable placeholder="请输入身份证号码" prefix-icon="el-icon-mobile-phone"
							v-model="loginForm.username">
						</el-input>
					</div>
				</el-form-item>
				<el-form-item prop="password">
					<div class="form_item">
						<el-input type="password" clearable placeholder="请输入密码" prefix-icon="el-icon-lock"
							v-model="loginForm.password">
						</el-input>
					</div>
				</el-form-item>
				<el-form-item prop="confirmPassword">
					<div class="form_item">
						<el-form-item prop="code" v-if="captchaEnabled">
							<el-input v-model="loginForm.code" auto-complete="off" placeholder="验证码" style="width: 70%"
								@keyup.enter.native="handleLogin">
								<svg-icon style="margin: 16px 0 0 6px;" slot="prefix" icon-class="validCode"
									class="el-input__icon input-icon" />
							</el-input>
							<div class="login-code">
								<img :src="codeUrl" @click="getCode" class="login-code-img" />
							</div>
						</el-form-item>
					</div>
				</el-form-item>
				<!-- <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;"><span
						style="color: #305BE1;">记住密码</span></el-checkbox> -->
			</el-form>
			<el-button class="loginIn" :loading="loading" size="medium" type="primary" style="width: 100%;"
				@click.native.prevent="handleLogin">
				<span v-if="!loading">立即登录</span>
				<span v-else>登 录 中...</span>
			</el-button>
			<div style="display: flex;justify-content: space-between;font-size: 14px;padding: 10px;">
				<div @click="toPassword" style="color: #a6a9ad;cursor: pointer;">忘记密码</div>
				<div @click="toRegister" style="color: #305BE1;cursor: pointer;">去注册>></div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getCodeImg,
		login,
		obtainPK
	} from "@/api/login";
	import Cookies from "js-cookie";
	import {
		encrypt,
		decrypt
	} from '@/utils/jsencrypt'
	import {
		setToken
	} from '@/utils/auth'
	import tencentCaptchaMixin from '@/mixins/tencentCaptcha'

	export default {
		name: "Login",
		mixins: [tencentCaptchaMixin],
		data() {
			return {
				codeUrl: "",
				loginForm: {
					username: "",
					password: "",
					rememberMe: false,
					code: "",
					uuid: "",
					keyId: "",
				},
				loginRules: {
					username: [{
						required: true,
						trigger: "blur",
						message: "请输入您的身份证号码"
					}],
					password: [{
						required: true,
						trigger: "blur",
						message: "请输入您的密码"
					}],
					code: [{
						required: true,
						trigger: "change",
						message: "请输入验证码"
					}]
				},
				loading: false,
				// 验证码开关
				captchaEnabled: false,
				// 注册开关
				register: false,
				redirect: undefined
			};
		},
		watch: {
			$route: {
				handler: function(route) {
					this.redirect = route.query && route.query.redirect;
				},
				immediate: true
			}
		},
		created() {
			this.getCode();
			this.getCookie();
		},
		methods: {
			getCode() {
				getCodeImg().then(res => {
					this.captchaEnabled = res.data.captchaEnabled === undefined ? true : res.data.captchaEnabled;
					if (this.captchaEnabled) {
						this.codeUrl = "data:image/gif;base64," + res.data.img;
						this.loginForm.uuid = res.data.uuid;
					}
				});
			},
			getCookie() {
				const username = Cookies.get("username");
				const password = Cookies.get("password");
				this.loginForm = {
					username: username === undefined ? this.loginForm.username : username,
					password: password === undefined ? this.loginForm.password : password,
				};
			},
			toPassword() {
				this.$router.push({
					path: "/password"
				})
			},
			toRegister() {
				this.$router.push({
					path: "/register"
				})
			},
			toIndex() {
				this.$router.push({
					path: "/"
				})
			},
			handleLogin() {
				this.$refs.loginForm.validate(valid => {
					if (valid) {
						this.loading = true;
						obtainPK().then((response) => {
							var pass = this.loginForm.password
							this.loginForm.password = encrypt(this.loginForm.password, response
								.data
								.publicKey)
							this.loginForm.keyId = response.data.keyId;
							login(this.loginForm).then((res) => {
								if (res.code == 200) {
									Cookies.set("username", this.loginForm.username, {
										expires: 30
									});
									Cookies.set("password", pass, {
										expires: 30
									});
									setToken(res.data.token)
									this.$router.push({
										path: "/"
									})
								} else {
									this.loginForm = {
										username: '',
										password: '',
									};
									this.loading = false;
								}
							}).finally(() => {
								this.loginForm = {
									username: '',
									password: '',
								};
								this.loading = false;
							});
						});
					}
				});
			}
		}
	};
</script>

<style scoped lang="scss">
	.login-box {
		width: 100%;
		height: 100vh;
		background: url(../assets/imgs/loginBg.png) no-repeat #000;
		background-size: 100% 100%;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.home_btn {
		cursor: pointer;
		font-size: 14px;
		color: #305BE1;
	}

	.form_area {
		width: 27%;
		background: #fff;
		padding: 20px;
		border-radius: 10px;



		.title-logo {
			width: 80px;
			height: 80px;
			margin-bottom: 20px;
			// border: 1px solid #dcdfe6;
			// border-radius: 5px;
		}

		.form_item {
			position: relative;

			.el-button {
				border: 0;
				background: none;
				padding: 0;
				border-radius: 0;
			}

			.bind_code_gain {
				position: absolute;
				top: calc(50% - 9px);
				right: 15px;
				font-size: 14px;
				font-family: MicrosoftYaHei;
				color: #20aee5;
				line-height: 18px;
				cursor: pointer;
				padding-left: 10px;
				border-left: 1px solid #d8d8d8;
			}
		}

		.loginIn {
			height: 50px;
			width: 360px;
			border-radius: 50px;
			margin: 0px 0 15px 0;
			background-color: #305BE1;
			box-shadow: #305BE1 0px 25px 20px -20px;
		}
	}

	@media screen and (max-width: 997px) {
		.form_area {
			width: 80%;
		}
	}

	.login-code {
		width: 28%;
		height: 38px;
		float: right;

		img {
			cursor: pointer;
			width: 100%;
			vertical-align: middle;
			height: 38px;
		}
	}

	.el-input ::v-deep .el-input__inner {
		background-color: #f8f8f8;
		border-radius: 24px;
		border: solid 1px #ededed;
		height: 48px;
	}

	.login-code-img {
		height: 38px;
	}

	::v-deep .el-checkbox .is-checked .el-checkbox__inner {
		background-color: #305BE1;
		border: 1px solid #305BE1;
	}

	::v-deep .el-checkbox .is-checked .el-checkbox__inner::after {
		border-color: #ffffff;
	}

	::v-deep .el-checkbox .is-checked .el-checkbox__inner span {
		color: #305BE1;
	}
</style>